import { createRouter, createWebHistory } from "vue-router";

import { tokenManager } from "@/app/shared/utils/tokenManager";

import app from "@/app/index";
import { validateUserProfileScopes } from "@/router/utils/validateUserProfileScopes";
import httpManager from "@/app/shared/utils/httpManager";
import NotFoundPage from "@/app/common/pages/NotFoundPage.vue";

const routes = [
  ...app.routes,
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFoundPage,
    meta: {
      requiresAuth: false,
      layout: "footer",
    },
  },
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  console.log(to, 'beforeEach router');

  if (to.path === "/plan-config/upgrade-downgrade") {
    const storedData = sessionStorage.getItem("authenticationData");
    if (storedData) {
      sessionStorage.removeItem("authenticationData");
      return true;
    } else {
      const tenant = to?.query?.tenant?.toString();
      console.log(tenant, 'tenant');
      if (tenant) {
        if (window.location.hostname == "localhost") {
          localStorage.setItem("workspace", tenant);
          return "/login?to=" + encodeURIComponent(to.fullPath);
        } else {
          localStorage.setItem("workspace", tenant);
          window.location.href = `https://${tenant}.${import.meta.env.VITE_HOSTNAME}/login?to=${encodeURIComponent(to.fullPath)}`;
        }
      }
      return "/login";
    }
  }

  try {
    const existAccessToken = tokenManager.existToken();
    const workspace = localStorage.getItem("workspace");

    if (to.meta.requiresAuth) {
      if (!existAccessToken) {
        if (workspace) return "/login";
        else return "/home";
      }

      if (!to.meta.hasScope) return true;

      httpManager.updateBaseURL(`https://${workspace}.backend.${import.meta.env.VITE_HOSTNAME}`);
      const hasRequiredScope = await validateUserProfileScopes(to.path);

      if (hasRequiredScope) return true;
      else return "/not-found";
    } else {
      return true;
    }
  } catch (error) {
    console.log(error, 'error router');
  }
});

router.afterEach((to, from) => {
  console.log('Cambio de ruta');
  const openRefreshNotification = localStorage.getItem('openRefreshNotification');
  if (openRefreshNotification == "true") {
    localStorage.removeItem('openRefreshNotification')
    document.dispatchEvent(new CustomEvent("refreshApp"));
    // window.location.reload();
  }

});
